import { FC } from 'react';

import { Text, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { OrdReport } from 'components/Admin/YandexDirectReport/OrdReport/OrdReport';
import { RefundReport } from 'components/Admin/YandexDirectReport/RefundReport/RefundReport';

const TrlKeys = {
    title: 'admin.directReport.title',
};

export const YandexDirectReport: FC = () => {
    const trl = useTrls();

    return (
        <>
            <Text typography="title-2-semibold">{trl(TrlKeys.title)}</Text>
            <VSpacing default={32} />
            <OrdReport />
            <VSpacing default={56} />
            <RefundReport />
            <VSpacing default={32} />
        </>
    );
};
